import React from 'react';
import { Tooltip } from 'antd';
import { DataType_AllOperation } from '../Sections/AllCheckouts/types';
import {
    MinusCircleOutlined, 
    SwapOutlined, 
    TeamOutlined, 
    PlusCircleOutlined
  } from '@ant-design/icons';
import { DataType } from '../../Contexts/UserContext/MovementAcountContext';

const getDescriptionSuffix = (
    associated_operation: string | undefined, 
    description: string | undefined, 
    is_deleting_operation: string | undefined, 
    is_sale: string | undefined,
    usdt_sale: string | undefined
) => {
    if(associated_operation && description && is_deleting_operation==='false'){
        let txt = ''
        if(is_sale){               
            switch(is_sale){
                case 'true':
                    txt = '(por venta)'
                    break;
                case 'false':
                    txt = '(por compra)'
                    break;
                default:
                    txt = 'usdt'
            }
        }
        if(usdt_sale){
            switch(usdt_sale){
                case 'true':
                    txt = '(x venta USDT)'
                    break;
                case 'false':
                    txt = '(x compra USDT)'
                    break;
                default:
                    txt = 'usdt'
            }
        }
        return txt
    }else{
        return ''
    }    
};

export const RenderOperationType = React.memo((value: { text: any; record: DataType_AllOperation | DataType }) => {
    let txt: React.ReactNode = ''; 
    let colorTxt =  'white';
    let is_buy_sale = ''
    let sign = value.record.main_currency_sign ? value.record.main_currency_sign : '' 
    let colorDetail = '#ff00c0'
    let sale: undefined | string = undefined
    let tooltip = ''

    switch (value.record.operation_type_id) {
        case '1':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#37bde0'}            
           
            txt = 'Depósito'; // Cuenta corriente           
            is_buy_sale = getDescriptionSuffix(
                value.record.associated_operation, 
                value.record.description, 
                value.record.is_deleting_operation, 
                value.record.is_sale,
                value.record.usdt_sale
            )            
        break;
        case '2':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#37bde0'}
            txt =  'Extracción'; // Cuenta corriente
            is_buy_sale = getDescriptionSuffix(
                value.record.associated_operation, 
                value.record.description, 
                value.record.is_deleting_operation,
                value.record.is_sale,
                value.record.usdt_sale
            )
            break;
        case '3':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#37bde0'}
            txt = 'Depósito'//(<>Transferencia <PlusCircleOutlined /> {/* Depósito c/comision */} </>);
            tooltip = 'Depósito'
            break;
        case '4':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#37bde0'}
            txt = 'Extracción'//(<>Transferencia <MinusCircleOutlined /> {/* Extracción s/comision */}</>);
            tooltip = 'Extracción'
            break;
        case '5':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#42A811'}
            txt = (<><SwapOutlined /> Movimiento  {/* Transferencia entre cajas */}</>);
            tooltip= 'Movimiento entre cajas'
            break;
        case '6':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#42A811'}
            txt = (<><TeamOutlined  style={{fontSize: 14}}/> Movimiento  {/* Transferencia entre cuentas */}</>);
            tooltip= 'Movimiento entre cuentas'
            break;
        case '7':
            let add = ''
            if(value.record.is_deleting_operation==='false') { colorTxt = '#ff00c0'}
            if(value.record.associated_operation){
                add = '(x venta USDT)'
            }
            txt = value.record.is_sale === 'true' ? `Venta ${sign} ` + add : `Compra ${sign} ` + add; 
            tooltip = value.record.is_sale === 'true' ? `Venta ${sign} ` + add : `Compra ${sign} ` + add;
            break;
        case '8':
        case '16':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#655fca'}
            txt = 'Comisión';
            tooltip = 'Comisión';
            break;
        case '9': //compra / venta de USDT
            if(value.record.is_deleting_operation==='false') { colorTxt = 'gray'}
            if(value.record.usdt_sale === 'true') {txt =  'Venta USDT'; tooltip = 'Venta USDT'}
            if(value.record.usdt_sale === 'false') {txt = 'Compra USDT'; tooltip = 'Compra USDT'}
            colorTxt = '#ff00c0';
            break;
        case '10':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#FFC107'}
            txt = 'Depósito en Proveedor';
            tooltip = 'Depósito en Proveedor';
            break;
        case '11':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#FFC107'}
            txt = 'Extracción en Proveedor';
            tooltip = 'Extracción en Proveedor';
            colorTxt = 'yellow';
            break;
        case '12':
            if(value.record.is_deleting_operation==='false') { colorTxt = 'gray'}
            txt = 'Comisión';
            tooltip= 'Comisión'
            break;
        case '13':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#9400D3'}
            txt = 'Costos Bancarios';
            tooltip='Costos Bancarios';
            break;
        case '14':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#FF4500'}
            txt = 'Depósito de fondos';
            tooltip= 'Depósito de fondos';
            break;
        case '15':
            if(value.record.is_deleting_operation==='false') { colorTxt = '#FF4500'}
            txt = 'Extracción de fondos';
            tooltip= 'Extracción de fondos';
            break;
        case '17':
            if(value.record.is_deleting_operation==='false') { colorTxt = 'rgb(86, 183, 244)'}
            txt = 'Transferencia c/ compra-venta';
            tooltip= 'Transferencia c/ compra-venta';
            break;
        default:
            txt = '';
            break;
    }
    if(value.record.deleted==='true' || value.record.is_deleting_operation==='true'){
        colorTxt =  'rgb(114, 114, 114)'
        colorDetail = 'rgb(114, 114, 114)'
    }
    return <Tooltip title={`${tooltip}` + ` ${is_buy_sale && is_buy_sale}` }>
            <span style={{ color: colorTxt, fontWeight: 700 }}>{txt}</span>
            {is_buy_sale && <span style={{ color: colorDetail, fontWeight: 700 }}> {is_buy_sale}</span>}
        </Tooltip> // Renderiza el contenido con el color correspondiente
});

export default RenderOperationType